import type { Section, SectionAction } from '../types';

/** Prefer `actions`; fall back to singular `action` for existing configs. */
export const getSectionActions = (section: Section): SectionAction[] => {
  if (section.actions?.length) return section.actions;
  if (section.action) return [section.action];
  return [];
};
